import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@/providers';
import { UserService } from '@/services';
import type { ReportEntityType } from '@/types';

export function useReportContent() {
  const { isLoggedIn } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({
      id,
      entityType,
      message,
    }: {
      id: string;
      entityType: ReportEntityType;
      message: string;
    }) => {
      return await UserService.reportContent(id, entityType, message);
    },
  });

  const reportContent = async (
    id: string,
    entityType: ReportEntityType,
    message: string,
  ): Promise<boolean> => {
    try {
      const result = await mutation.mutateAsync({ id, entityType, message });
      return result;
    } catch {
      return false;
    }
  };

  return {
    reportContent,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    // Only show reporting if user is logged in
    shouldShow: isLoggedIn,
  };
}
